"use strict";

/*global
 window, document, console, require, Foundation
 */

import 'lib/foundation-explicit-pieces';
import AOS from 'aos';

document.addEventListener('DOMContentLoaded', () => {
    $(document).foundation();


    // Fader plungin
    AOS.init();



    // TEXTS page
    // text tabs set first as default
	$('.tabs-title:first-of-type').addClass('is-active');
	$('.tabs-panel:first-of-type').addClass('is-active');


	if(window.location.pathname == '/' || window.location.pathname == '/en/') {
		// Frontpage background slider
		$(".slider").slick({
			infinite: true,
			autoplay: true,

			dots: false,
			autoplaySpeed: 7500,
			speed: 250,
			fade: true,
			cssEase: 'linear',
			arrows: false,
		});

	}

	$('body').on('click', '.tabs-title', function () {
		var dataid = $(this).data('id');


		console.log('btn pressed: ' + dataid);

		$('.tabs-lower .tabs-title').removeClass('is-active');
		$('.tabs-lower .tabs-title[data-id='+dataid+']').addClass('is-active');

		$('.top-tabs .tabs-title').removeClass('is-active');
		$('.top-tabs .tabs-title[data-id='+dataid+']').addClass('is-active');

	});




	// NAV SCROLLER

	var loggedPos = 0;

	var prevScrollpos = window.pageYOffset;
	window.onscroll = function() {
		var currentScrollPos = window.pageYOffset;

		loggedPos = (prevScrollpos - 30);

		if (prevScrollpos > currentScrollPos) {

			if (prevScrollpos > currentScrollPos) {
				if (currentScrollPos < loggedPos) {
					$('header').removeClass('hidden').addClass('visible');
				}
			}

		} else {
			if(prevScrollpos < 200 ) {
				// if scrolld less than 200px from top, show always.
				$('header').removeClass('hidden').addClass('visible');
			} else {

				if($('header').hasClass('hidden')) {
					$('.nav-icon').removeClass('open');
				} else {
					$('header').removeClass('visible').addClass('hidden');
				}

				if($('.nav-toggle-label').hasClass('open')) {
					$('.mobile').removeClass('visible');
					$('.nav-toggle-label').removeClass('open');
				}
			}
		}

		prevScrollpos = currentScrollPos;

	};

	// var navIcon = $('.nav-icon');
	var navIcon = $('.nav-toggle');

	navIcon.on('click', function () {
		$('.nav-toggle-label').toggleClass('open');
		$('.mobile').toggleClass('visible');
	});




	// Työt-page post sort by category

	$('body').on('click', '.btn-cat', function(){

		const btn = $(this);
		let paged = 1;
		let cat = '';

		if (btn.hasClass('selected')){
			btn.removeClass('selected');
		} else {
			$('.load-news').removeClass('selected');
			btn.addClass('selected');
		}

		cat = $('.btn-cat.selected').data('cat') ? $('.btn-cat.selected').data('cat') : '';
		$('.btn-cat').prop('disabled', true);
		$('.btn-cat').prop('disabled', false);

		var showDisableLayer = function() {
			$('<div class="overlay"><div class="color"></div><div class="spinner"></div></div>').appendTo(document.body);
		};
		var hideDisableLayer = function() {
			$(".overlay").fadeOut(500).remove();
		};

		$.ajax({
			url: brbrApp.ajaxUrl,
			type: 'GET',
			data: {
				action: 'get_cases',
				cat: cat,
				paged: paged,
			},

			beforeSend: function() {
				$('.btn-cat').prop('disabled', true);
				$('.btn-cat').addClass('disabled');
				showDisableLayer(); // Show the layer of glass.
				console.log('before get_cases');

			},
			success:function(data){
				$('.btn-cat').prop('disabled', false);
				$('.btn-cat').removeClass('disabled');
				console.log('success get_cases');

				hideDisableLayer(); // Hides the layer of glass.

			}

		}).always(function(data){

			if (data.html) {
				$('.load-more').data('paged', paged);

				if(btn.hasClass('load-more')) {
					$('.article-list').append(data.html);
				} else {
					$('.article-list').html(data.html);
				}
				if (data.maxpages <= paged) {
					$('.load-more').addClass('disabled').hide();
				}
			}
		});

	});




	var btn = $('#button');

	$(window).scroll(function() {
		if ($(window).scrollTop() > 500) {
			btn.addClass('show');
		} else {
			btn.removeClass('show');
		}
	});

	btn.on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({scrollTop:0}, '250');
	});












	//sort by year

	$('body').on('click', '.dropper a', function(){

		const btn = $(this);
		let paged = 1;
		let year = $(this).data('year');

		var lang = $('.title span').data('lang');

		if (btn.hasClass('btn-year')) {
			if (btn.hasClass('selected')){
				btn.removeClass('selected');
				year = '';
				$('.title').html('<span>' + lang + '</span>');
			} else {
				$('.btn-year').removeClass('selected');
				btn.addClass('selected');
				$('.title span').html(year);
				$('.dropper a').removeClass('selected');
				$('.dropdown .title').addClass('selected');
			}

			// year = $('.btn-year.selected').data('year') ? $('.btn-year.selected').data('year') : '';
			$('.btn-year').prop('disabled', true);
			$('.btn-year').prop('disabled', false);

			var showDisableLayer = function() {
				$('<div class="overlay"><div class="color"></div><div class="spinner"></div></div>').appendTo(document.body);
			};
			var hideDisableLayer = function() {
				$(".overlay").fadeOut(500).remove();
			};

			console.log('year: ' + year);

			$.ajax({
				url: brbrApp.ajaxUrl,
				type: 'GET',
				data: {
					action: 'get_casesYear',
					paged: paged,
					year: year
				},

				beforeSend: function() {
					$('.btn-year').prop('disabled', true);
					$('.btn-year').addClass('disabled');
					showDisableLayer(); // Show the layer of glass.
				},
				success:function(data){
					$('.btn-year').prop('disabled', false);
					$('.btn-year').removeClass('disabled');
					hideDisableLayer(); // Hides the layer of glass.
					console.log('success');
					console.log(year);
				}

			}).always(function(data){

				if (data.html) {


//					$('.all-work .grid-x').append(data.html);
					$('.all-work .grid-x').html(data.html);

				}
			});
		} else {
			console.log('----------------');
			console.log('else');

			btn.removeClass('selected');

			// $('.title span').html('Suodatus');

			$('.title').html('<span>' + lang + '</span>');

			$('.dropper a').removeClass('selected');
			$(this).addClass('selected');

			$('.dropdown .title').removeClass('selected');
			$('.all-work').addClass('selected');

			year = '';
			console.log('year = empty');

			$.ajax({
				url: brbrApp.ajaxUrl,
				type: 'GET',
				data: {
					action: 'get_casesYear',
					paged: paged,
					year: year
				},

				beforeSend: function() {
					$('.btn-year').prop('disabled', true);
					$('.btn-year').addClass('disabled');
				},
				success:function(data){
					$('.btn-year').prop('disabled', false);
					$('.btn-year').removeClass('disabled');
					console.log('reset');
					console.log('vuosi: ' + year);
				}

			}).always(function(data){

				if (data.html) {

//					$('.all-work .grid-x').append(data.html);
					$('.all-work .grid-x').html(data.html);

				}
			});

		} // else end

	});


	// FANCYBOX image popup
	/*
	$(".zoomer").fancybox({
			closeEffect : 'none',
			nextEffect  : 'none',
			prevEffect  : 'none',
			title : {
				type : null
			},
			arrows: 'none',
			type: 'image'
		});
	*/

	$('.zoomer').fancybox();






	$('.tabs-content').on('change.zf.tabs', function () {
		console.log('1');
	});








	$('body').on('click', '.btn-retro', function(){

		const btn = $(this);
		let paged = 1;
		let cat = '';

		if (btn.hasClass('selected')){
			btn.removeClass('selected');
		} else {
			$('.load-news').removeClass('selected');
			btn.addClass('selected');
		}

		cat = $('.btn-retro.selected').data('cat') ? $('.btn-retro.selected').data('cat') : '';
		$('.btn-retro').prop('disabled', true);
		$('.btn-retro').prop('disabled', false);

		var showDisableLayer = function() {
			$('<div class="overlay"><div class="color"></div><div class="spinner"></div></div>').appendTo(document.body);
		};
		var hideDisableLayer = function() {
			$(".overlay").fadeOut(500).remove();
		};

		$.ajax({
			url: brbrApp.ajaxUrl,
			type: 'GET',
			data: {
				action: 'get_retro',
				cat: cat,
				paged: paged,
			},

			beforeSend: function() {
				$('.btn-retro').prop('disabled', true);
				$('.btn-retro').addClass('disabled');
				showDisableLayer(); // Show the layer of glass.
				console.log('before get_retro');

			},
			success:function(data){
				$('.btn-retro').prop('disabled', false);
				$('.btn-retro').removeClass('disabled');
				console.log('success get_retro');

				hideDisableLayer(); // Hides the layer of glass.

			}

		}).always(function(data){

			if (data.html) {
				$('.load-more').data('paged', paged);

				if(btn.hasClass('load-more')) {
					$('.article-list').append(data.html);
				} else {
					$('.article-list').html(data.html);
				}
				if (data.maxpages <= paged) {
					$('.load-more').addClass('disabled').hide();
				}
			}
		});

	});




});